import { Appearance } from "react-native";

const theme = Appearance.getColorScheme() || "light";

const THEMES = {
  dark: {
    DEFAULT_COLOR: "#239C9D",
    FOOTER_COLOR: "#239C9D",
    defaultColor: "gray",
    containerBg: "#F3F2F1", 
    containerWhite: "#243251",
    almostBlack: "#243251",
    lightGray: "#f3f2f1",
    darkGray: "#DADADA",
    headerBg: "#239C9D",
    footer: "#FFF", 
    footerText: "#ABADB3",
    title: "#F4F6FA",
    subTitle: "#F4F6FA",
    weekContainer: "#768B9D",
    icon: "#FFF",
    iconBlack: "#FFF",
    toggle: {
      bg: "#F3F2F1",
      text: "#ABADB3",
      blue: "#239C9D",
      selected: "#239C9D",
      selectedText: "#FFFFFF",
    },
    week: {
      dayText: "#F4F6FA",
    },
    menuText: "#007AFF",
    borderColor: "#F5F5F5",
    moodOpacity: 0.7,
    highlightColor: "#F6EC91",
    atusColor: "#405584"
  },
  light: {
    DEFAULT_COLOR: "#239C9D",
    FOOTER_COLOR: "#239C9D",
    defaultColor: "#41A9CE",
    containerBg: "#F3F2F1",
    containerWhite: "#FFF",
    almostBlack: "#243251",
    lightGray: "#f3f2f1",
    darkGray: "#DADADA",
    headerBg: "#239C9D",
    footer: "#FFF",
    footerText: "#ABADB3",
    title: "#F4F6FA",
    subTitle: "#F4F6FA",
    weekContainer: "#768B9D",
    icon: "#41A9CE",
    iconBlack: "#F4F6FA",
    toggle: {
      bg: "#F3F2F1",
      text: "#ABADB3",
      blue: "#239C9D",
      selected: "#239C9D",
      selectedText: "#FFFFFF",
    },
    week: {
      dayText: "#F4F6FA",
    },
    menuText: "#007AFF",
    borderColor: "#F5F5F5",
    moodOpacity: 0.7,
    highlightColor: "#F6EC91",
    atusColor: "#405584"
  },
};

export default THEMES[theme];
